import React from 'react'
import Note from '../Note'
import { Card, CardList } from '../../components/Card'
import Buttons from '../Buttons'
import Button from '../../components/inputs/Button'
import Icon from '../../components/Icon'

const Notes = React.memo(({ notes, onClickNextNotes, notesFromKey }) => {
    return (
        (notes && notes.data) &&
        <Card>
            <CardList
                data={notes.data}
                cmp={({ ...props }) => (
                    <Note
                        {...props}
                        buttonsTranslation={{
                            submit: notesFromKey && notesFromKey['add-note']['buttons']['save'],
                            cancel: notesFromKey && notesFromKey['add-note']['buttons']['cancel']
                        }}
                    />
                )}
                showOpenButton={false}
            />
            {
                notes.nextid &&
                <Buttons centered>
                    <Button style={{ transform: 'rotate(90deg)' }} onClick={onClickNextNotes}>
                        <Icon name="arrow" width="24" height="24" />
                    </Button>
                </Buttons>
            }
        </Card>
    )
})

export default Notes